import * as React from 'react';

import classnames from 'classnames';
import styles from './scroll-shadow.module.css';

type Props = {
    isActive: boolean;
    orientation: 'top' | 'bottom';
};

export function ScrollShadow(props: Props) {
    const styleNames = classnames({
        [styles['scroll-shadow-container--top']]: props.orientation === 'top',
        [styles['scroll-shadow-container--bottom']]: props.orientation === 'bottom',
        [styles['scroll-shadow-container--active']]: props.isActive,
    });

    return (
        <div className={styleNames}>
            <div className={styles.shadow} />
            <div className={styles['shadow-blocker']} />
        </div>
    );
}
